const MainLayout = ({ children, isMenuOpen }) => {
  return (
    <div
      className={`transition-[margin] duration-300 ease-in-out ${
        isMenuOpen ? "mt-64" : "mt-16"
      }`}
    >
      <main className="max-w-4xl mx-auto px-4 py-12">{children}</main>
    </div>
  );
};

export default MainLayout;
